export default {
  CANCEL: 'Cancel',
  REQUEST_ACCESS: 'Request Access',
}
